import { ChevronRight, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { CoachHealthCompactPresentation } from "@/lib/coachHealth/coachHealthPresentationContracts";

interface CoachHealthRecordedContextRowProps {
  readonly compact: CoachHealthCompactPresentation;
  readonly controlsId: string;
  readonly open: boolean;
  readonly onOpen: () => void;
  readonly onRetry?: () => void;
}

export function CoachHealthRecordedContextRow({
  compact,
  controlsId,
  open,
  onOpen,
  onRetry,
}: CoachHealthRecordedContextRowProps) {
  const isDisclosure = compact.actionLabel === "View recorded context";
  const action = isDisclosure ? onOpen : onRetry;

  return (
    <section
      aria-label="Coaching Health"
      className="rounded-xl border border-border/70 bg-card px-4 py-3 shadow-sm"
    >
      <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">
            {compact.label}
          </p>
          <p className="mt-1 text-sm font-medium text-foreground">{compact.statement}</p>
          {compact.snapshotNote ? (
            <p className="mt-1 text-xs text-muted-foreground">{compact.snapshotNote}</p>
          ) : null}
        </div>
        {compact.actionLabel && action ? (
          <Button
            type="button"
            variant="ghost"
            className="min-h-11 shrink-0 justify-between gap-2 self-stretch px-3 sm:self-center"
            aria-controls={isDisclosure ? controlsId : undefined}
            aria-expanded={isDisclosure ? open : undefined}
            onClick={action}
          >
            {compact.actionLabel}
            {isDisclosure ? (
              <ChevronRight className="h-4 w-4" aria-hidden="true" />
            ) : (
              <RefreshCw className="h-4 w-4" aria-hidden="true" />
            )}
          </Button>
        ) : null}
      </div>
    </section>
  );
}
